<template>
  <div class="modal_group">
    <div class="modal_group__header">
      <h4 class="title">{{ translate('server.groups') }}</h4>
    </div>
    <fg-input
        v-model="name"
        type="text"
        :label="translate('server.instance_group.name')"
        :placeholder="translate('server.instance_group.name')"
        :disabled="saving"
    />
    <div class="modal_group__footer">
      <button type="button" class="btn btn-success btn-fill btn-wd" :disabled="saving || !name.trim()" @click.prevent="save_group">
        {{ translate(group.id ? 'save' : 'btn.create') }}
      </button>
      <button type="button" class="btn btn-danger btn-fill btn-wd" :disabled="saving" @click="$emit('close')">
        {{ translate('close_modal') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditServerGroup',
  props: {
    group: Object
  },
  data () {
    return {
      name: this.group.name || '',
      saving: false
    }
  },
  methods: {
    save_group () {
      if (this.saving || !this.name.trim()) return
      this.saving = true
      if (this.group.id) {
        this.$http.v1.updateServerGroup(this.group.id, {...this.group, name: this.name.trim()}, () => {
          this.global_notify('info', this.translate('server.group_save'))
          this.$emit('update')
        }).finally(() => {
          this.saving = false
        })
      } else {
        this.$http.v1.createServerGroup({name: this.name.trim()}, () => {
          this.global_notify('info', this.translate('server.group_created'))
          this.$emit('update')
        }).finally(() => {
          this.saving = false
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal_group{
  padding: 10px;
  &__header{
    padding-bottom: 10px;
    .title{
      margin: 0;
      text-align: center;
    }
  }
  &__footer{
    display: flex;
    justify-content: center;
    .btn{
      margin: 0 5px;
    }
  }
}
</style>
